import { render, staticRenderFns } from "./EnrollmentWaitingList.vue?vue&type=template&id=5be00248&scoped=true&"
import script from "./EnrollmentWaitingList.vue?vue&type=script&lang=js&"
export * from "./EnrollmentWaitingList.vue?vue&type=script&lang=js&"
import style0 from "./EnrollmentWaitingList.vue?vue&type=style&index=0&id=5be00248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be00248",
  null
  
)

export default component.exports